import { ITabstop } from '@src/slide/domain/ui-model/element-modeles/property/text/interface/editor-styles.interface';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import { IUserPriviledgeService } from '@src/slide/application/service/user-priviledge-service/user-priviledge-service.interface';
import { IEditorInstanceService } from '@src/slide/application/service/editor-instance-service/editor-instance-service.interface';

// todo: 这两个声明之前是在ParagraphManager导出的，之后降其他地方对这两个声明的依赖改到这里
export enum LineHeightType {
    Multi = 'multiply',
    Fixed = 'fixed',
}

export interface IUpdateProps {
    alignmentType?: string;
    lineHeight?: number;
    lineHeightType?: LineHeightType | '';
    marginLeft?: number;
    textIndent?: number;
    spaceBefore?: number;
    spaceAfter?: number;
    tabSize?: number;
    tabList?: ITabstop[];
}

/**
 * 行间距管理
 */
export interface IParagraphManager {
    alignmentType?: string;
    marginLeft?: number;
    textIndent?: number;
    spaceBefore?: number;
    spaceAfter?: number;
    lineHeight?: number;
    lineHeightType?: LineHeightType;
    tabList?: ITabstop[];
    tabSize?: number;

    /**
     * 展示自定义行间距对话框
     */
    showParagraph(config?: { isTabstopModalVisible: boolean }): void;

    /**
     * 隐藏自定义行间距对话框
     */
    hideParagraph(): void;

    /**
     * 更新行间距
     */
    updateUI(updateProps: IUpdateProps): void;
    updateUIWithModel(updateProps: IUpdateProps, model): void;

    setSelectionServiceDelegate(selectionService: ISelectionService): void;
    setUserPriviledgeServiceDelegate(userPriviledgeService: IUserPriviledgeService): void;
    setEditorInstanceServiceDelegate(editorInstanceService: IEditorInstanceService): void;
    getSelectedStyle(): void;
}
